import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from '../../globals';
import { PendingRequest } from '../modal/pendingrequest';
import { Plan } from '../modal/plan';

@Injectable({
    providedIn: 'root'
})

export class PlanDataService {
    constructor(private httpclient: HttpClient, private global: Globals) {
    }

  
    GetPlanData() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/getPlanData", { headers:headers });
    }
    GetPlanDataByMaxAmount(userid) {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get(this.global.G_apiUrl + "/getPlanDataWithMaxAmount/"+userid, { headers:headers });
    }

    GetPlanById(planid){
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
        return this.httpclient.get<Plan>(this.global.G_apiUrl + "/getPlanById/"+planid, { headers:headers });
    }

}
